// OP1WebWindowManagerSurface (build review SEP.23.2026): the area where app
// windows float. DESKTOP holds this surface and the OP1WebsiteDock as
// siblings; this surface holds ONLY OP1WebAppWindow instances.
//
// Fills its container and gives OP1WebAppWindow instances a positioned
// ancestor to place themselves against with `position: absolute`. It also
// marks itself with `data-window-manager-surface` so a window can find the
// bounds it must keep its header inside of (see OP1WebAppWindow.jsx).
//
// Can look empty in Studio/at runtime when no windows are open - its job is
// behavior (providing the coordinate surface), not visuals.
import React from "react";
import styles from "./OP1WebWindowManagerSurface.module.css";

const OP1WebWindowManagerSurface = React.forwardRef(
  function OP1WebWindowManagerSurface({ className, children, ...rest }, ref) {
    return (
      <div
        ref={ref}
        data-window-manager-surface=""
        className={[styles.surface, className].filter(Boolean).join(" ")}
        {...rest}
      >
        {children}
      </div>
    );
  }
);

export default OP1WebWindowManagerSurface;
